import "./style.scss";
import { Link, useLocation } from "react-router-dom";
import { tabsPagesConst } from "@/src/constants/tabs-pages";
import { useEffect, useState } from "react";

function TabsPages() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>("Home");
  const [disableTab, setDisableTab] = useState<boolean>(false);

  useEffect(() => {
    const currentPathName = location.pathname
      .replace("/", "")
      .replace(/^./, (c) => c.toUpperCase());
    setActiveTab(currentPathName || "Home");
    if (
      currentPathName !== "" &&
      currentPathName !== "Programs" &&
      currentPathName !== "Search" &&
      currentPathName !== "Contact"
    ) {
      setDisableTab(true);
    } else {
      setDisableTab(false);
    }
  }, [location.pathname]);

  const handleTabClick = (id: string) => {
    setActiveTab(id);
  };

  return (
    <div className="tabs-pages">
      <div className={`tabs-pages-groups ${disableTab ? "disable" : ""}`}>
        {tabsPagesConst.tabs.map((tab, index) => (
          <Link
            to={tab.link}
            key={index}
            onClick={() => handleTabClick(tab.id)}
            className={`${activeTab === tab.id ? "active" : ""}`}
          >
            <tab.img />
            <p>{tab.text}</p>
          </Link>
        ))}
      </div>
      <div className="tabs-pages-navigation">
        <Link to={tabsPagesConst.navigation.link}>
          <tabsPagesConst.navigation.img />
        </Link>
      </div>
      <div className="tabs-pages-apply-online">
        <Link to="/apply-online">Оставить заявку</Link>
      </div>
    </div>
  );
}

export default TabsPages;
